import { FavoriteButtonItem } from '@/components/FavoriteButton/FavoriteButton';
import { tracker } from '@/utility/tracking/tracker';
import { FeatureProductData } from '@/utility/tracking/types';

const getTrackingProduct = (favoriteItem: FavoriteButtonItem): FeatureProductData => {
  return {
    amount: 1,
    productTypeId: favoriteItem.productTypeId,
    appearanceId: favoriteItem.appearanceId,
    articleId: favoriteItem.compositionId,
    articleName: favoriteItem.label,
    sellableId: favoriteItem.sellableId,
    sizeId: favoriteItem.sizeId ? favoriteItem.sizeId : undefined,
    price: favoriteItem.price,
    shopId: favoriteItem.shopId,
  };
};

export const trackFavoriteAddition = (favoriteItem: FavoriteButtonItem) => {
  tracker.trackFeature({
    featureUsed: 'sellable-favorited',
    detail: {},
    product: getTrackingProduct(favoriteItem),
  });
};

export const trackFavoriteRemoval = (favoriteItem: FavoriteButtonItem) => {
  tracker.trackFeature({
    featureUsed: 'sellable-unfavorited',
    detail: {},
    product: getTrackingProduct(favoriteItem),
  });
};
